import type { SidebarSortMode } from './use-sidebar-manual-order';

export type { SidebarSortMode } from './use-sidebar-manual-order';

export const SIDEBAR_SORT_MODES: SidebarSortMode[] = [
  'manual',
  'alphabetical',
  'folders-first',
  'docs-first',
];
